import { render, staticRenderFns } from "./PreguntasFrecuentesView.vue?vue&type=template&id=35a7241c&scoped=true&"
import script from "./PreguntasFrecuentesView.vue?vue&type=script&lang=ts&"
export * from "./PreguntasFrecuentesView.vue?vue&type=script&lang=ts&"
import style0 from "./PreguntasFrecuentesView.vue?vue&type=style&index=0&id=35a7241c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a7241c",
  null
  
)

export default component.exports